import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppState } from 'src/app/store/reducers';

import * as fromInstutionUserReducer from './instution-user.reducer';


export const currentState = (state: AppState) => (state[fromInstutionUserReducer.instutionUsersFeatureKey]);

export const selectAllInstutionUsers = createSelector(currentState, fromInstutionUserReducer.selectAll);

export const selectTotalInstutionUsers = createSelector(currentState, fromInstutionUserReducer.selectTotal);

export const selectModifiedInstutionUsers = createSelector(selectAllInstutionUsers, (instutionsUsers) => {
  return instutionsUsers.map((instutionsUser) => {
    return {
      ...instutionsUser,
      title:instutionsUser?.profile.profileTitle,
      fullName: `${instutionsUser?.profile.profileTitle} ${instutionsUser?.profile?.userFirstName} ${instutionsUser?.profile.userLastName}`,
      firstName:instutionsUser?.profile?.userFirstName,
      lastName:instutionsUser?.profile.userLastName,
      email:instutionsUser?.profile?.userEmail,
      phone:instutionsUser?.profile?.profilePhone,
      designation: instutionsUser?.userDesignation?.designationShortForm,
      modRole: instutionsUser?.role?.roleName,
      modStatus: instutionsUser?.profile?.profileIsDeactivated ? "Deactivated": "Active",
      modUserType: instutionsUser?.userType?.replaceAll('_', ' '),
      // role: instutionsUser?.role?.roleName
      modIsAdmin: instutionsUser?.role?.roleIsAdmin,
      name: `${instutionsUser?.profile.profileTitle} ${instutionsUser?.profile?.userFirstName} ${instutionsUser?.profile.userLastName}`,
      value: instutionsUser?.profile?.profileUniqueId,
    };
  });
});



